import { Component, Prop, toNative, Vue } from '@natureos/vue-facing-decorator';

@Component({ name: 'Card' })
class Card extends Vue {
  @Prop({ required: false, default: 'p-6' })
  public readonly contentClass!: string;

  @Prop({ required: false, default: null })
  public readonly image!: string | null;
}

export default toNative(Card);
export { default as Card } from './card.component.vue';
